import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import InnerHTML from 'dangerously-set-html-content';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm, formValueSelector, reset, resetSection, FormSection, change } from 'redux-form';
import { required } from 'redux-form-validators';
import { Agreements, DefaultButton, ReduxTextField, ReduxSelectField, BasicModal } from 'common/components';
import WithdrawalGate from 'common/bankVerification/WithdrawalGate';
import { withTheme } from 'common/styling/theme';
import WarningMessage from 'client/_components/WarningMessage';
import classNames from 'classnames';
import { ReloadIcon } from 'common';
import PaymentSystemButton from '../PaymentSystemButton';
import SecondPaymentsForm from '../SecondPaymentsForm';
import arrowDown from './arrowDown.svg';
import { getExchangeRate, makeDeposit, makePaymentLpa, makeWithdraw, resetPaymentForm } from '../../_redux';
import { staticStyles, getDynamicStyles } from './style';
import iconRadio from './images/iconRadio.svg';
import iconRadioActive from './images/iconRadioActive.svg';
import ChooseLpaButton from '../ChooseLpaButton';
import SavedMethods from '../SavedMethods';
import { PaymentsInfoConfirmationForm } from '../index';

const PaymentsForm = ({
  accounts,
  walletAccounts,
  paymentSystemList,
  availableLpasList,
  openStepLPA,
  setOpenStepLPA,
  paymentForm,
  resetPaymentForm,
  handleSubmit,
  dispatch,
  profile,
  invalid,
  pristine,
  submitting,
  action,
  loadAccount,
  baseValue,
  addons,
  theme,
  error,
  history,
  getExchangeRate,
  exchangeRate,
  exchangeRateIsLoaded,
  currencyValue,
  amountValue,
  currentAccount,
  accountValue,
  accountAmount,
  walletAccount,
  confirmationForm,
  confirmationFormIsLoaded,
}) => {
  /* screen-size */
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  useMemo(() => {
    window.addEventListener('resize', () => setScreenSize(window.innerWidth));
  }, []);

  const [savedRequisiteId, setSavedRequisiteId] = useState(null);

  const [openStep1, setOpenStep1] = useState(true);

  const [disabledStep2, setDisabledStep2] = useState(true);
  const [openStep2, setOpenStep2] = useState(false);

  const [disabledStep3, setDisabledStep3] = useState(true);
  const [openStep3, setOpenStep3] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const [lastEditedField, setLastEditedField] = useState('amount');

  const [selectedLpa, setSelectedLpa] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const submitText = openStepLPA ? 'justConfirm' : 'clientContinue';

  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const step2FormTitle = !openStepLPA ? 'clientSpecifyTheSum' : 'justChooseLPA';

  const accountsFiltered = useMemo(
    () => accounts.filter(acc => !acc.isDemo && !acc.isBlocked && !acc.loading),
    [accounts]
  );

  const walletAccountsFiltered = useMemo(
    () => walletAccounts.filter(acc => !acc.isDemo && !acc.isBlocked && !acc.loading),
    [accounts]
  );

  const isMultiWallet = addons.includes('walletAccounts');

  /* eslint-disable */
  const typeOperation = ['deposit', 'wallet_deposit'].includes(action) ? 'deposit' : 'withdraw';
  const search = window.location.search.split('=')[1];
  const [typeAccount, setTypeAccount] = useState(
    addons.includes('wallet') || isMultiWallet ? (search ? search : 'wallet') : 'account'
  );
  const [operation, setOperation] = useState(null);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [valueForConfirmation, setValueForConfirmation] = useState(null);

  const handleConfirmModalToggle = () => {
    setIsConfirmModalOpen(isOpen => !isOpen);
  };

  const openConfirmationModal = values => {
    setIsConfirmModalOpen(true);
    setValueForConfirmation(values);
  };
  /* eslint-enable */

  const getOperation = typeAccount => {
    if (typeAccount === 'wallet' && isMultiWallet) {
      setOperation(typeOperation);

      return;
    }

    setOperation(typeAccount === 'account' ? typeOperation : `wallet_${typeOperation}`);
  };
  useMemo(() => getOperation(typeAccount), []);

  const [selectedSystem, setSelectedSystem] = useState(paymentSystemList[0].title);
  const isDeposit = ['wallet_deposit', 'deposit'].includes(action);
  const lpaPercent = isDeposit ? selectedLpa?.depositCommissionPercent : selectedLpa?.withdrawCommissionPercent;
  const [calculatedReceiveAmount, setCalculatedReceiveAmount] = useState(0);

  const selectedSystemInfo = useMemo(
    () => paymentSystemList?.find(system => system.title === selectedSystem),
    [paymentSystemList, selectedSystem]
  );

  const description = isDeposit ? selectedSystemInfo.descriptionDeposit : selectedSystemInfo.descriptionWithdraw;
  const operationNum = isDeposit ? 0 : 1;
  const minDepositTitleNew =
    document.location.hostname === 'my.swaycapitalgroup.com' ? 'justSwayCapitalMinDeposit' : 'justMinDeposit';
  const maxDepositTitleNew =
    document.location.hostname === 'my.swaycapitalgroup.com' ? 'justSwayCapitalMaxDeposit' : 'justMaxDeposit';

  const handlePaymentSystemClick = title => {
    setSelectedSystem(title);

    dispatch(reset('payments-form'));
    resetPaymentForm();
  };

  const handlePaymentSystemConfirm = title => {
    handlePaymentSystemClick(title);
    setOpenStep2(true);
    setDisabledStep2(false);
    setOpenStep1(false);
    setOpenStep3(false);
    setDisabledStep3(true);
  };

  const handleSavedMethodClick = (id, title) => {
    setSavedRequisiteId(id);
    handlePaymentSystemConfirm(title);
  };

  const handleResetPaymentForm = () => {
    dispatch(reset('payments-form'));
    resetPaymentForm();
  };

  if (!paymentSystemList.length) {
    return false;
  }

  const calculateReceiveAmount = (_, value) => {
    const sendAmount = parseFloat(value);
    const commission = Math.floor(lpaPercent);
    const calculatedCommission = (sendAmount / 100) * commission;
    const receiveAmount = sendAmount + calculatedCommission;
    setCalculatedReceiveAmount(receiveAmount);
  };

  const shouldPassWalletAccount = isMultiWallet && typeAccount === 'wallet';

  const submit = handleSubmit(values => {
    const { accountAmount, ...requestValues } = values;

    return openStepLPA
      ? makePaymentLpa(
          {
            amount: {
              amount: values.amount,
              currency: values.currency,
            },
            operation: operationNum,
            agent: selectedLpa.user.id,
          },
          dispatch
        )
      : isDeposit
      ? makeDeposit(
          {
            ...requestValues,
            account: shouldPassWalletAccount ? values.walletAccount : values.account,
            paymentMethod: selectedSystemInfo.id,
            operation,
            savedRequisiteId,
          },
          dispatch
        )
      : makeWithdraw(
          {
            ...requestValues,
            account: shouldPassWalletAccount ? values.walletAccount : values.account,
            paymentMethod: selectedSystemInfo.id,
            operation,
            savedRequisiteId,
          },
          dispatch
        );
  });

  const properties = paymentForm?.requisitesForm?.form ?? {};

  const isNullForm = Object.keys(properties).length ? properties.widget === 'nullform' : true;

  useEffect(() => {
    if (paymentForm?.request.status === 'waiting_verification' && isNullForm) {
      setModalOpen(true);
    }
  }, [paymentForm]);

  const currentCurrencyTo = typeAccount === 'wallet' && addons.includes('wallet') ? 'USD' : currentAccount?.currency;

  const getExchangeRateSafe = () => {
    if (currentCurrencyTo && currencyValue) {
      getExchangeRate({ currencyFrom: currencyValue, currencyTo: currentCurrencyTo, withdrawal: !isDeposit });
    }
  };

  useEffect(() => {
    getExchangeRateSafe();
  }, [currentAccount?.currency, currencyValue, getExchangeRate]);

  useEffect(() => {
    let timeoutId = null;

    if (exchangeRate.ttl) {
      timeoutId = setTimeout(() => {
        getExchangeRateSafe();
      }, exchangeRate.ttl * 1000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [exchangeRate, getExchangeRate]);

  const amountAfterExchange =
    amountValue && exchangeRate.rate && currencyValue && exchangeRateIsLoaded
      ? (Number(amountValue) * exchangeRate.rate).toFixed(exchangeRate.digitsAfterSeparatorTo)
      : null;

  const showAccountAmount =
    currentCurrencyTo &&
    (accountValue || walletAccount || (typeAccount === 'wallet' && addons.includes('wallet'))) &&
    currencyValue &&
    exchangeRateIsLoaded &&
    exchangeRate?.to !== exchangeRate?.from;

  const syncFromAmount = amount => {
    if (!exchangeRate.rate || amount === '' || amount == null) {
      dispatch(change('payments-form', 'accountAmount', ''));
      return;
    }

    dispatch(
      change(
        'payments-form',
        'accountAmount',
        (Number(amount) * exchangeRate.rate).toFixed(exchangeRate.digitsAfterSeparatorTo)
      )
    );
  };

  const syncFromAccountAmount = accountAmount => {
    if (!exchangeRate.rate || accountAmount === '' || accountAmount == null) {
      dispatch(change('payments-form', 'amount', ''));
      return;
    }

    dispatch(
      change(
        'payments-form',
        'amount',
        (Number(accountAmount) / exchangeRate.rate).toFixed(exchangeRate.digitsAfterSeparatorFrom)
      )
    );
  };

  const handleAmountChange = value => {
    setLastEditedField('amount');
    syncFromAmount(value);
  };

  const handleAccountAmountChange = value => {
    setLastEditedField('accountAmount');
    syncFromAccountAmount(value);
  };

  useEffect(() => {
    if (!exchangeRateIsLoaded || !exchangeRate.rate) {
      return;
    }

    if (lastEditedField === 'amount') {
      syncFromAmount(amountValue);
    } else {
      syncFromAccountAmount(accountAmount);
    }
  }, [exchangeRate.rate, exchangeRateIsLoaded]);

  const rate = exchangeRate.rate ? Number(exchangeRate.rate) : null;

  let exchangeString = null;

  if (rate) {
    if (rate >= 1) {
      exchangeString = `1 ${exchangeRate.from} = ${rate.toFixed(exchangeRate.digitsAfterSeparatorTo)} ${
        exchangeRate.to
      }`;
    } else {
      exchangeString = `1 ${exchangeRate.to} = ${(1 / rate).toFixed(exchangeRate.digitsAfterSeparatorFrom)} ${
        exchangeRate.from
      }`;
    }
  }

  const accountsOptions = accountsFiltered.map(item => {
    const balance = baseValue === 'balance' ? item.balance : item.marginFree;
    return {
      label: `${item.accountTypeTitle} : ${item.login} ${balance ? `( ${balance.amount}${balance.currency} )` : ''}`,
      value: item.id,
    };
  });

  const walletAccountsOptions = walletAccountsFiltered.map(item => {
    const balance = baseValue === 'balance' ? item.balance : item.marginFree;
    return {
      label: `${item.accountTypeTitle} : ${item.login} ${balance ? `( ${balance.amount}${balance.currency} )` : ''}`,
      value: item.id,
    };
  });

  const isDisclaimerSofVisible =
    typeOperation === 'withdraw' &&
    profile?.status === 'need_income_sources' &&
    addons.includes('incomesSourcesValidation');

  return (
    <>
      <SavedMethods
        typeOperation={typeOperation}
        handleSavedMethodClick={handleSavedMethodClick}
        savedRequisiteId={savedRequisiteId}
      />
      <div className="PaymentsForm">
        {isDisclaimerSofVisible && (
          <div className="PaymentsForm__warning">
            <WarningMessage
              headerTextId="accountRequiresAdditionalVerification"
              bodyTextId="accountWithdrawSofWarning"
            />
          </div>
        )}
        {/* step-1 */}
        <div
          className={classNames('PaymentsForm__step-1', {
            'PaymentsForm__step-1--open': openStep1,
          })}>
          {/* eslint-disable */}
          <div
            className="PaymentsForm__step-1-wrap-title"
            onClick={() => {
              setOpenStep1(!openStep1);
            }}>
            {/* eslint-enable */}
            <div className="PaymentsForm__step-1-number">
              <span>1</span>
            </div>
            <div className="PaymentsForm__step-1-title">
              <FormattedMessage id="clientSelectMethod">{txt => txt}</FormattedMessage>
            </div>
            <div
              className={classNames('PaymentsForm__step-1-arrow', {
                'PaymentsForm__step-1-arrow--hide': !openStep1,
              })}>
              <img src={arrowDown} alt="arrow-down" />
            </div>
          </div>

          {openStep1 && (
            <>
              <div className="PaymentsForm__step-1-systems">
                {/* eslint-disable */}
                {paymentSystemList.map((system, i) => (
                  <PaymentSystemButton
                    key={system.id}
                    systemInfo={system}
                    active={system.title === selectedSystem && !openStepLPA}
                    openStepLPA={openStepLPA}
                    onClick={() => {
                      handlePaymentSystemClick(system.title);
                      setOpenStep2(false);
                      setDisabledStep2(true);
                      setOpenStep3(false);
                      setDisabledStep3(true);
                      setSavedRequisiteId(null);
                      setOpenStepLPA(false);
                    }}
                    onConfirm={e => {
                      e.stopPropagation();
                      handlePaymentSystemConfirm(system.title);
                    }}
                    ind={++i <= 4 ? i : i % 4}
                    screenSize={screenSize}
                    isDeposit={isDeposit}
                  />
                ))}
                {profile.lpa ? (
                  <ChooseLpaButton
                    active={openStepLPA}
                    onClick={() => {
                      setOpenStepLPA(true);
                      setOpenStep2(false);
                      setDisabledStep2(true);
                      setOpenStep3(false);
                      setDisabledStep3(true);
                    }}
                    screenSize={screenSize}
                    isDeposit={isDeposit}
                  />
                ) : null}
              </div>
              {selectedSystemInfo && screenSize > 767 && (
                <>
                  {!openStepLPA ? (
                    <div className="PaymentsForm__step-1-payment-info-wrap">
                      <div className="PaymentsForm__step-1-payment-info">
                        <div className="PaymentsForm__step-1-payment-info-left">
                          <img src={selectedSystemInfo.iconUrl} alt="icon-payment-method" />
                        </div>
                        <div className="PaymentsForm__step-1-payment-info-right">
                          <div className="PaymentsForm__step-1-payment-info-deposits">
                            <div className="PaymentsForm__step-1-payment-info-deposits-item">
                              <div className="PaymentsForm__step-1-payment-info-deposits-item-title">
                                <FormattedMessage id={isDeposit ? minDepositTitleNew : 'justMinWithdrawal'}>
                                  {txt => txt}
                                </FormattedMessage>
                              </div>
                              <div className="PaymentsForm__step-1-payment-info-deposits-item-desc">
                                {selectedSystemInfo.minAmount}
                              </div>
                            </div>
                            <div className="PaymentsForm__step-1-payment-info-deposits-item">
                              <div className="PaymentsForm__step-1-payment-info-deposits-item-title">
                                <FormattedMessage id={isDeposit ? maxDepositTitleNew : 'justMaxWithdrawal'}>
                                  {txt => txt}
                                </FormattedMessage>
                              </div>
                              <div className="PaymentsForm__step-1-payment-info-deposits-item-desc">
                                {selectedSystemInfo.maxAmount}
                              </div>
                            </div>
                            <div className="PaymentsForm__step-1-payment-info-deposits-item">
                              <div className="PaymentsForm__step-1-payment-info-deposits-item-title">
                                <FormattedMessage id="justCommission">{txt => txt}</FormattedMessage>
                              </div>
                              <div className="PaymentsForm__step-1-payment-info-deposits-item-desc">
                                {selectedSystemInfo.commission}
                              </div>
                            </div>
                          </div>
                          <div className="PaymentsForm__step-1-payment-info-description">
                            <InnerHTML html={description} key={1} />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  <div className="PaymentsForm__step-1-payment-info-confirm">
                    <DefaultButton
                      type="submit"
                      textId="justConfirm"
                      onClick={() => {
                        setOpenStep1(false);
                        setDisabledStep2(false);
                        setOpenStep2(true);
                      }}
                      filled
                    />
                  </div>
                </>
              )}
              {openStepLPA && screenSize <= 767 && (
                <div className="PaymentsForm__step-1-payment-info-confirm-mobile-lpa">
                  <DefaultButton
                    type="submit"
                    textId="justConfirm"
                    onClick={() => {
                      setOpenStep2(true);
                      setDisabledStep2(false);
                      setOpenStep1(false);
                      setOpenStep3(false);
                      setDisabledStep3(true);
                    }}
                    filled
                  />
                </div>
              )}
            </>
          )}
        </div>

        {/* step-2 */}
        <div
          className={classNames('PaymentsForm__step-2', {
            'PaymentsForm__step-2--open': openStep2,
            'PaymentsForm__step-2--disabled': disabledStep2,
          })}>
          {/* eslint-disable */}
          <div
            className="PaymentsForm__step-2-wrap-title"
            onClick={() => {
              if (disabledStep2) return;
              setOpenStep2(!openStep2);
            }}>
            {/* eslint-enable */}
            <div className="PaymentsForm__step-2-number">
              <span>2</span>
            </div>
            <div className="PaymentsForm__step-2-title">
              <FormattedMessage id={step2FormTitle}>{txt => txt}</FormattedMessage>
            </div>
            <div
              className={classNames('PaymentsForm__step-2-arrow', {
                'PaymentsForm__step-2-arrow--hide': !openStep2,
              })}>
              <img src={arrowDown} alt="arrow-down" />
            </div>
          </div>

          {/* open-step-2 */}
          <div
            className={classNames('PaymentsForm__step-2-wrap', {
              'PaymentsForm__step-2-wrap--hide': !openStep2,
            })}>
            {openStepLPA ? (
              <form onSubmit={submit}>
                <div className="PaymentsForm__step-2-form-subwrap">
                  <div
                    className={classNames('PaymentsForm__step-2-form-left', {
                      'PaymentsForm__step-2-form-left--right-empty': !paymentForm,
                    })}>
                    <div className="PaymentsForm__step-2-form-account">
                      <Field
                        name="account"
                        textId="justChooseLPA"
                        validate={required()}
                        options={availableLpasList?.map(item => ({
                          value: item,
                          label: `${item.user.firstName}
                          ${item.user.middleName ? item.user.middleName : ''}
                          ${item.user.lastName}`,
                        }))}
                        component={ReduxSelectField}
                        onChange={(event, value) => setSelectedLpa(value)}
                        disabled={submitting || !!paymentForm}
                        searchable
                      />
                    </div>
                    {selectedLpa ? (
                      <>
                        {/* amount */}
                        <div className="PaymentsForm__step-2-form-amount">
                          <Field
                            name="amount"
                            type="number"
                            textId="justAmount"
                            validate={[required()]}
                            component={ReduxTextField}
                            disabled={submitting || !!paymentForm}
                            onChange={calculateReceiveAmount}
                          />
                        </div>

                        {/* currency */}
                        <div className="PaymentsForm__step-2-form-currency">
                          <Field
                            name="currency"
                            textId="justCurrency"
                            validate={required()}
                            options={selectedLpa.currencies.map(item => ({
                              value: item,
                              label: item,
                            }))}
                            component={ReduxSelectField}
                            onChange={(event, value) => setSelectedCurrency(value)}
                            disabled={submitting || !!paymentForm}
                          />
                        </div>
                        <div className="PaymentsForm__step-2-payment-info">
                          <div className="PaymentsForm__step-2-payment-info-item">
                            {!isDeposit ? (
                              <>
                                <div className="PaymentsForm__step-2-payment-info-item-title">
                                  <FormattedMessage id="justCommission">{txt => txt}</FormattedMessage>
                                </div>
                                <div className="PaymentsForm__step-2-payment-info-item-commission">{lpaPercent}</div>
                              </>
                            ) : (
                              <>
                                <div className="PaymentsForm__step-2-payment-info-item-title">
                                  <FormattedMessage id="justLPA">{txt => txt}</FormattedMessage>
                                </div>
                                <div className="PaymentsForm__step-2-payment-info-item-commission">
                                  <span>{`${selectedLpa.user.firstName}
                                ${selectedLpa.user.middleName ? selectedLpa.user.middleName : ''}
                                ${selectedLpa.user.lastName}`}</span>
                                  <span>{selectedLpa.user.email}</span>
                                </div>
                              </>
                            )}
                          </div>
                          <div className="PaymentsForm__step-2-payment-info-item">
                            <div className="PaymentsForm__step-2-payment-info-item-description">
                              <FormattedMessage id="justDescription">{txt => txt}</FormattedMessage>
                            </div>
                            <div
                              className="PaymentsForm__step-2-payment-info-item-desc"
                              dangerouslySetInnerHTML={{
                                __html: isDeposit
                                  ? selectedLpa.depositDescription || '-'
                                  : selectedLpa.withdrawDescription || '-',
                              }}
                            />
                          </div>
                          <div className="PaymentsForm__step-2-form-info-line-break" />
                          <div className="PaymentsForm__step-2-payment-info-item-receive">
                            {calculatedReceiveAmount && selectedCurrency && !isDeposit ? (
                              <div className="PaymentsForm__step-2-form-info-line-1">
                                <div className="PaymentsForm__step-2-form-info-title-1">
                                  <FormattedMessage id="clientSendAmount">{txt => txt}</FormattedMessage>
                                </div>
                                <div className="PaymentsForm__step-2-form-info-text-1">
                                  {`${calculatedReceiveAmount} ${selectedCurrency}`}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>

                  {paymentForm && (
                    <div className="PaymentsForm__step-2-form-right">
                      <div className="PaymentsForm__step-2-form-info-line-1">
                        <div className="PaymentsForm__step-2-form-info-title-1">
                          <FormattedMessage id="clientYouWillGet">{txt => txt}</FormattedMessage>
                        </div>
                        <div className="PaymentsForm__step-2-form-info-text-1">
                          {paymentForm.request.amountWithCommission.amount}
                          {` `}
                          {paymentForm.request.amountWithCommission.currency}
                        </div>
                      </div>
                      <div className="PaymentsForm__step-2-form-info-line-commission">
                        <div className="PaymentsForm__step-2-form-info-title-commission">
                          <FormattedMessage id="justCommission">{txt => txt}</FormattedMessage>
                        </div>
                        <div className="PaymentsForm__step-2-form-info-text-commission">
                          {paymentForm.request.commission?.amount} {paymentForm.request.commission?.currency}
                        </div>
                      </div>
                      <div className="PaymentsForm__step-2-form-info-line-2">
                        <div className="PaymentsForm__step-2-form-info-title-2">
                          <FormattedMessage id="clientCurrentConversionCourse">{txt => txt}</FormattedMessage>:
                        </div>
                        <div className="PaymentsForm__step-2-form-info-text-2">
                          {paymentForm.request.conversionCourse}
                        </div>
                      </div>
                      <div className="PaymentsForm__step-2-form-info-line-3">
                        <div className="PaymentsForm__step-2-form-info-line-3-icon">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="9.5" stroke="#0AA1E2" />
                            <path
                              d="M11.052 7.902C11.052 8.67667 11.024 9.386 10.968 10.03C10.912 10.674 10.842 11.3227 10.758 11.976H9.554C9.46067 11.3227 9.386 10.674 9.33 10.03C9.274 9.37667 9.246 8.66733 9.246 7.902V5.298H11.052V7.902ZM11.262 14.076C11.262 14.4027 11.1547 14.6687 10.94 14.874C10.7253 15.0793 10.4593 15.182 10.142 15.182C9.834 15.182 9.568 15.0793 9.344 14.874C9.12933 14.6687 9.022 14.4027 9.022 14.076C9.022 13.7493 9.12933 13.4833 9.344 13.278C9.568 13.0633 9.834 12.956 10.142 12.956C10.4593 12.956 10.7253 13.0633 10.94 13.278C11.1547 13.4833 11.262 13.7493 11.262 14.076Z"
                              fill="#0AA1E2"
                            />
                          </svg>
                        </div>
                        <div className="PaymentsForm__step-2-form-info-line-3-text">
                          <FormattedMessage id="clientWarningAmountTranslation">{txt => txt}</FormattedMessage>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* step-2-submit-button */}
                {!paymentForm && (
                  <div className="PaymentsForm__step-2-form-submit">
                    <DefaultButton
                      type="submit"
                      textId={submitText}
                      disabled={invalid || pristine || submitting}
                      loading={submitting}
                      filled
                    />
                  </div>
                )}
              </form>
            ) : (
              <WithdrawalGate enabled={!isDeposit && !paymentForm}>
                {/* radio-wallet-account */}
                {(addons.includes('wallet') || isMultiWallet) && (
                  <div className="PaymentsForm__step-2-radio-wrap">
                    {/* eslint-disable */}
                    {/* radio-wallet */}
                    {/* eslint-disable */}
                    <div
                      className="PaymentsForm__step-2-radio"
                      onClick={() => {
                        setTypeAccount('wallet');
                        getOperation('wallet');
                        handleResetPaymentForm();
                        setOpenStep3(false);
                        setDisabledStep3(true);
                      }}>
                      {/* eslint-enable */}
                      <FormattedMessage id="boWallet">
                        {txt => (
                          <>
                            <img src={typeAccount === 'wallet' ? iconRadioActive : iconRadio} alt="icon-radio" />
                            {txt}
                          </>
                        )}
                      </FormattedMessage>
                    </div>

                    {/* radio-account */}
                    {/* eslint-disable */}
                    <div
                      className="PaymentsForm__step-2-radio"
                      onClick={() => {
                        setTypeAccount('account');
                        getOperation('account');
                        handleResetPaymentForm();
                        setOpenStep3(false);
                        setDisabledStep3(true);
                      }}>
                      {/* eslint-enable */}
                      <FormattedMessage id="justAccount">
                        {txt => (
                          <>
                            <img src={typeAccount === 'account' ? iconRadioActive : iconRadio} alt="icon-radio" />
                            {txt}
                          </>
                        )}
                      </FormattedMessage>
                    </div>
                    {/* eslint-enable */}
                  </div>
                )}

                <form onSubmit={submit}>
                  <div className="PaymentsForm__step-2-form-subwrap">
                    <div
                      className={classNames('PaymentsForm__step-2-form-left', {
                        'PaymentsForm__step-2-form-left--right-empty': !paymentForm,
                      })}>
                      {/* wallet */}
                      {typeAccount === 'wallet' && addons.includes('wallet') && (
                        <div className="PaymentsForm__step-2-form-wallet wallet-balance PaymentsForm__wallet-balance">
                          <FormattedMessage id="justWalletBalance">
                            {txt => <span className="PaymentsForm__wallet-caption">{txt}:</span>}
                          </FormattedMessage>
                          <span className="PaymentsForm__wallet-amount">{profile.walletBalance} USD</span>
                        </div>
                      )}

                      {/* multi-wallet */}
                      {typeAccount === 'wallet' && isMultiWallet && (
                        <div className="PaymentsForm__step-2-form-account">
                          <Field
                            name="walletAccount"
                            textId="chooseWallet"
                            validate={required()}
                            options={walletAccountsOptions}
                            component={ReduxSelectField}
                            onChange={(event, value) => {
                              loadAccount(value);
                              dispatch(resetSection('payments-form', 'amount'));
                              dispatch(change('payments-form', 'accountAmount', ''));
                            }}
                            disabled={submitting || !!paymentForm}
                            searchable
                          />
                        </div>
                      )}

                      {/* account */}
                      {typeAccount === 'account' && (
                        <div className="PaymentsForm__step-2-form-account">
                          <Field
                            name="account"
                            textId="chooseAccount"
                            validate={required()}
                            options={accountsOptions}
                            component={ReduxSelectField}
                            onChange={(event, value) => {
                              loadAccount(value);
                              dispatch(resetSection('payments-form', 'amount'));
                              dispatch(change('payments-form', 'accountAmount', ''));
                            }}
                            disabled={submitting || !!paymentForm}
                            searchable
                          />
                        </div>
                      )}

                      <div className="PaymentsForm__step-2-form-row">
                        {/* amount in account currency */}
                        <div
                          className={classNames('PaymentsForm__step-2-form-accountAmountWrapper', {
                            'PaymentsForm__step-2-form-accountAmountWrapper--visible': showAccountAmount,
                          })}>
                          <div className="PaymentsForm__step-2-form-accountAmount">
                            <Field
                              name="accountAmount"
                              type="number"
                              textId={`Amount in ${currentCurrencyTo}`}
                              component={ReduxTextField}
                              disabled={submitting || !!paymentForm}
                              shouldUseOnlyFormValue
                              autoComplete="off"
                              onChange={(e, value) => handleAccountAmountChange(value)}
                            />
                          </div>
                        </div>

                        <div
                          className={classNames('PaymentsForm__step-2-form-dividerWrapper', {
                            'PaymentsForm__step-2-form-dividerWrapper--visible': showAccountAmount,
                          })}>
                          <div className="PaymentsForm__step-2-form-divider">~</div>
                        </div>

                        {/* amount */}
                        <div className="PaymentsForm__step-2-form-amount">
                          <Field
                            name="amount"
                            type="number"
                            textId="justAmount"
                            validate={[required()]}
                            component={ReduxTextField}
                            disabled={submitting || !!paymentForm}
                            shouldUseOnlyFormValue
                            autoComplete="off"
                            onChange={(e, value) => handleAmountChange(value)}
                          />
                        </div>
                        {/* currency */}
                        <div className="PaymentsForm__step-2-form-currency">
                          <Field
                            name="currency"
                            textId="justCurrency"
                            validate={required()}
                            options={selectedSystemInfo.currencies.map(item => ({
                              value: item,
                              label: item,
                            }))}
                            component={ReduxSelectField}
                            disabled={submitting || !!paymentForm}
                          />
                        </div>
                      </div>
                      {error && (
                        <div className="PaymentsForm__step-2-Html-FilterError">
                          <InnerHTML html={error} key={3} />
                        </div>
                      )}
                    </div>

                    {amountAfterExchange && !paymentForm && exchangeRate.to !== exchangeRate.from && (
                      <div className="PaymentsForm__step-2-form-conversation">
                        <div className="PaymentsForm__step-2-form-info-line-1">
                          <div className="PaymentsForm__step-2-form-info-line-1-container">
                            <div className="PaymentsForm__step-2-form-info-line-1-amount">
                              <div className="PaymentsForm__step-2-form-info-title-1">
                                <FormattedMessage id="convertedAmount">{txt => txt}</FormattedMessage>
                              </div>
                              <div className="PaymentsForm__step-2-form-info-text-1">
                                {amountAfterExchange}
                                {` `}
                                {exchangeRate.to}
                              </div>
                            </div>
                            <div className="PaymentsForm__step-2-form-info-title-1-without-commission">
                              <FormattedMessage id="excludingCommission">{txt => txt}</FormattedMessage>
                            </div>
                          </div>

                          <div className="PaymentsForm__step-2-form-info-line-1-conversation-rate">
                            <div className="PaymentsForm__step-2-form-info-line-1-conversation-rate-icon">
                              <ReloadIcon />
                            </div>
                            <div className="PaymentsForm__step-2-form-info-line-1-conversation-rate-info">
                              {exchangeString}
                            </div>
                          </div>
                        </div>
                        <div className="PaymentsForm__step-2-form-info-line-3">
                          <div className="PaymentsForm__step-2-form-info-line-3-icon">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="10" cy="10" r="9.5" stroke="#0AA1E2" />
                              <path
                                d="M11.052 7.902C11.052 8.67667 11.024 9.386 10.968 10.03C10.912 10.674 10.842 11.3227 10.758 11.976H9.554C9.46067 11.3227 9.386 10.674 9.33 10.03C9.274 9.37667 9.246 8.66733 9.246 7.902V5.298H11.052V7.902ZM11.262 14.076C11.262 14.4027 11.1547 14.6687 10.94 14.874C10.7253 15.0793 10.4593 15.182 10.142 15.182C9.834 15.182 9.568 15.0793 9.344 14.874C9.12933 14.6687 9.022 14.4027 9.022 14.076C9.022 13.7493 9.12933 13.4833 9.344 13.278C9.568 13.0633 9.834 12.956 10.142 12.956C10.4593 12.956 10.7253 13.0633 10.94 13.278C11.1547 13.4833 11.262 13.7493 11.262 14.076Z"
                                fill="#0AA1E2"
                              />
                            </svg>
                          </div>
                          <div className="PaymentsForm__step-2-form-info-line-3-text">
                            <FormattedMessage id="clientWarningAmountTranslation">{txt => txt}</FormattedMessage>
                          </div>
                        </div>
                      </div>
                    )}

                    {paymentForm && (
                      <div className="PaymentsForm__step-2-form-right">
                        <div className="PaymentsForm__step-2-form-info-line-1">
                          <div className="PaymentsForm__step-2-form-info-line-1-amount">
                            <div className="PaymentsForm__step-2-form-info-title-1">
                              <FormattedMessage id="clientYouWillGet">{txt => txt}</FormattedMessage>
                            </div>
                            <div className="PaymentsForm__step-2-form-info-text-1">
                              {paymentForm.request.amountWithCommission.amount}
                              {` `}
                              {paymentForm.request.amountWithCommission.currency}
                            </div>
                          </div>
                          {paymentForm.request.amount.currency !==
                            paymentForm.request.amountWithCommission.currency && (
                            <div className="PaymentsForm__step-2-form-info-line-1-conversation-rate">
                              <div className="PaymentsForm__step-2-form-info-line-1-conversation-rate-icon">
                                <ReloadIcon />
                              </div>
                              <div className="PaymentsForm__step-2-form-info-line-1-conversation-rate-info">
                                {paymentForm.request.conversionCourse}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="PaymentsForm__step-2-form-info-line-commission">
                          <div className="PaymentsForm__step-2-form-info-title-commission">
                            <FormattedMessage id="justCommission">{txt => txt}</FormattedMessage>
                          </div>
                          <div className="PaymentsForm__step-2-form-info-text-commission">
                            {paymentForm.request.commission?.amount} {paymentForm.request.commission?.currency}
                          </div>
                        </div>
                        <div className="PaymentsForm__step-2-form-info-line-3">
                          <div className="PaymentsForm__step-2-form-info-line-3-icon">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="10" cy="10" r="9.5" stroke="#0AA1E2" />
                              <path
                                d="M11.052 7.902C11.052 8.67667 11.024 9.386 10.968 10.03C10.912 10.674 10.842 11.3227 10.758 11.976H9.554C9.46067 11.3227 9.386 10.674 9.33 10.03C9.274 9.37667 9.246 8.66733 9.246 7.902V5.298H11.052V7.902ZM11.262 14.076C11.262 14.4027 11.1547 14.6687 10.94 14.874C10.7253 15.0793 10.4593 15.182 10.142 15.182C9.834 15.182 9.568 15.0793 9.344 14.874C9.12933 14.6687 9.022 14.4027 9.022 14.076C9.022 13.7493 9.12933 13.4833 9.344 13.278C9.568 13.0633 9.834 12.956 10.142 12.956C10.4593 12.956 10.7253 13.0633 10.94 13.278C11.1547 13.4833 11.262 13.7493 11.262 14.076Z"
                                fill="#0AA1E2"
                              />
                            </svg>
                          </div>
                          <div className="PaymentsForm__step-2-form-info-line-3-text">
                            <FormattedMessage id="clientWarningAmountTranslation">{txt => txt}</FormattedMessage>
                          </div>
                        </div>
                      </div>
                    )}

                    <FormSection name="agreements">
                      <Agreements agreements={selectedSystemInfo.agreements} disabled={submitting || !!paymentForm} />
                    </FormSection>
                  </div>

                  {/* step-2-submit-button */}
                  {!paymentForm && (
                    <div className="PaymentsForm__step-2-form-submit">
                      <DefaultButton
                        type="submit"
                        textId="clientContinue"
                        disabled={invalid || pristine || submitting}
                        loading={submitting}
                        filled
                      />
                    </div>
                  )}

                  {/* step-2-continue-step-3 */}
                  {paymentForm && !isNullForm && (
                    <div className="PaymentsForm__step-2-continue">
                      <DefaultButton
                        type="button"
                        textId="clientContinue"
                        disabled={invalid || pristine || submitting}
                        loading={submitting}
                        filled
                        onClick={() => {
                          setOpenStep2(false);
                          setOpenStep3(true);
                          setDisabledStep3(false);
                        }}
                      />
                    </div>
                  )}

                  {/* finist-step-3 */}
                  {paymentForm && isNullForm && (
                    <div className="PaymentsForm__step-2-step-3">
                      {paymentForm.disclaimerForm && (
                        <div className="PaymentsForm__step-2-step-3-disclaimer">
                          <h2 className="PaymentsForm__step-2-step-3-disclaimer-title">
                            <FormattedMessage id="justWarning" />
                          </h2>
                          <span className="PaymentsForm__step-2-step-3-disclaimer-text">
                            {paymentForm.disclaimerForm}
                          </span>
                        </div>
                      )}
                      <SecondPaymentsForm
                        paymentForm={paymentForm}
                        onResetForm={() => {
                          handleResetPaymentForm();
                          setOpenStep3(false);
                          setDisabledStep3(true);
                          setOpenStep2(true);
                        }}
                        addons={addons}
                        history={history}
                        isNullForm={isNullForm}
                      />
                    </div>
                  )}
                </form>
              </WithdrawalGate>
            )}
          </div>
        </div>

        {/* step-3 */}
        {!isNullForm && (
          <div
            className={classNames('PaymentsForm__step-3', {
              'PaymentsForm__step-3--open': openStep3,
              'PaymentsForm__step-3--disabled': disabledStep3,
            })}>
            {/* eslint-disable */}
            <div
              className="PaymentsForm__step-3-wrap-title"
              onClick={() => {
                if (disabledStep3) return;
                setOpenStep3(!openStep3);
              }}>
              {/* eslint-enable */}
              <div className="PaymentsForm__step-3-number">
                <span>3</span>
              </div>
              <div className="PaymentsForm__step-3-title">
                <FormattedMessage id="clientEnterAdditionalInformation">{txt => txt}</FormattedMessage>
              </div>
              <div
                className={classNames('PaymentsForm__step-3-arrow', {
                  'PaymentsForm__step-3-arrow--hide': !openStep3,
                })}>
                <img src={arrowDown} alt="arrow-down" />
              </div>
            </div>

            {openStep3 && (
              <div className="PaymentsForm__step-3-wrap">
                {/* payment-will-get */}
                {/* finish-step-3 */}
                {paymentForm && (
                  <div className="PaymentsForm__step-3-second-form">
                    <SecondPaymentsForm
                      paymentForm={paymentForm}
                      onResetForm={() => {
                        handleResetPaymentForm();
                        setOpenStep3(false);
                        setDisabledStep3(true);
                        setOpenStep2(true);
                      }}
                      addons={addons}
                      history={history}
                      isNullForm={isNullForm}
                      isAllFieldsRequired={false}
                      openConfirmationModal={openConfirmationModal}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <BasicModal
          captionId="justConfirmationMessageSent"
          isOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
        />

        {/* for koraPay */}
        {paymentForm && valueForConfirmation && confirmationForm && confirmationFormIsLoaded && (
          <BasicModal
            isOpen={isConfirmModalOpen}
            modalClassName="VerifyModal"
            captionId="justConfirmPayment"
            onRequestClose={handleConfirmModalToggle}>
            <PaymentsInfoConfirmationForm
              paymentConfirmInfo={confirmationForm}
              onClose={handleConfirmModalToggle}
              requisites={valueForConfirmation}
              sendRequisitesAfterConfirmForm
              history={history}
            />
          </BasicModal>
        )}

        <style jsx global>
          {dynamicStyles}
        </style>
        <style jsx global>
          {staticStyles}
        </style>
      </div>
    </>
  );
};

PaymentsForm.propTypes = {
  loadAccount: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  accounts: PropTypes.array,
  walletAccounts: PropTypes.array,
  addons: PropTypes.array.isRequired,
  paymentSystemList: PropTypes.array.isRequired,
  availableLpasList: PropTypes.array.isRequired,
  openStepLPA: PropTypes.bool.isRequired,
  setOpenStepLPA: PropTypes.func.isRequired,
  resetPaymentForm: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  baseValue: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  paymentForm: PropTypes.object,
  theme: PropTypes.object,
  error: PropTypes.string,
  getExchangeRate: PropTypes.func.isRequired,
  exchangeRate: PropTypes.object.isRequired,
  currencyValue: PropTypes.string,
  amountValue: PropTypes.string,
  currentAccount: PropTypes.object.isRequired,
  exchangeRateIsLoaded: PropTypes.bool.isRequired,
  accountValue: PropTypes.number,
  accountAmount: PropTypes.string,
  walletAccount: PropTypes.number,
  confirmationForm: PropTypes.object.isRequired,
  confirmationFormIsLoaded: PropTypes.bool.isRequired,
};

PaymentsForm.defaultProps = {
  accounts: [],
  walletAccounts: [],
  paymentForm: null,
  error: null,
  theme: {},
  currencyValue: '',
  amountValue: '',
  accountValue: null,
  accountAmount: '',
  walletAccount: null,
};

const selector = formValueSelector('payments-form');

export default compose(
  withTheme(),
  withRouter,
  connect(
    state => ({
      accounts: state.client.common.accounts,
      walletAccounts: state.client.multiWallet.walletAccounts,
      accountValue: selector(state, 'account') || null,
      walletAccount: selector(state, 'walletAccount') || null,
      currencyValue: selector(state, 'currency') || null,
      amountValue: selector(state, 'amount') || null,
      accountAmount: selector(state, 'accountAmount') || null,
      addons: state.interfaceConfig.addons,
      baseValue: state.interfaceConfig.baseValue,
      profile: state.user.profile,
      paymentForm: state.client.payments.paymentForm,
      exchangeRate: state.client.payments.exchangeRate,
      currentAccount: state.client.common.currentAccount,
      exchangeRateIsLoaded: state.client.payments.exchangeRateIsLoaded,
      confirmationForm: state.client.payments.confirmationForm,
      confirmationFormIsLoaded: state.client.payments.confirmationFormIsLoaded,
    }),
    {
      resetPaymentForm: () => resetPaymentForm.request(),
      makePaymentLpa: () => makePaymentLpa.request(),
      getExchangeRate: data => getExchangeRate.request(data),
    }
  ),
  reduxForm({
    form: 'payments-form',
    onSubmitSuccess: (result, dispatch, { history, addons }) => {
      const properties = result?.requisitesForm?.form ?? {};
      const isNullForm = Object.keys(properties).length ? properties.widget === 'nullform' : true;
      if (result.agent) {
        history.push(`/localpayments/${result.id}`);
      }
      if (result.request.status === 'waiting_verification' && isNullForm) {
        setTimeout(() => {
          history.push(
            addons.includes('wallet') ? `/wallet/dw/${result.request.id}` : `/payments/dw/${result.request.id}`
          );
        }, 3000);
      }
    },
  })
)(PaymentsForm);
export { PaymentsForm };
